import { Flow_0_0_2, getData, getFullItemTwo, getSelectedItemOne, getAllInfo, getCurrentUser } from '@flexus/core';
import { map, take, filter, skipWhile, first, pluck } from 'rxjs/operators';
import gql from 'graphql-tag';
import { BET_27 } from './BET_27';
import { CollapseActionPanel, setActionPanelItems } from '../../../../app-shell-features';

import { Validators } from '@angular/forms';
import { environment } from 'apps/studio/src/environments/environment';
import { MISCELLANEOUS_CLAIMS_PAYMENT_CHECKS } from './miscellaneous_claims_payment_checks';
import { PAYMENT_CHECKS } from './payment_checks';
import { forkJoin, EMPTY } from 'rxjs';

export const BET_39: Flow_0_0_2 = {
	id: '39',
	name: 'job_invoiced_invalid_claim',
	itemType: 'flow',
	onStateInit: inst => {
		inst.store.dispatch(new CollapseActionPanel());
	},
	onStateDestroy: inst => {
		inst.store.dispatch(new CollapseActionPanel());
	},
	header: {
		title: (store, bf) => {
			return store.select(getFullItemTwo).pipe(
				filter(x => !!x),
				skipWhile((itemTwo: any) => {
					return itemTwo === null || itemTwo === undefined;
				}),
				first(itemTwo => itemTwo !== null || itemTwo !== undefined),
				map((itemTwo: any) => {
					if (itemTwo) {
						return `Job Invoiced - Invalid Claim: ${itemTwo?.claim?.loan_information?.mavenclaimnumber} - ${itemTwo?.claim?.applicant?.surname}`;
					} else {
						return 'Job Invoiced - Invalid Claim';
					}
				})
			);
		},
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'Approve call-out fee invoice'
		},
		viewRoles: {
			0: '--'
		}
	},

	events: {
		invalidateQueryDataIfVatRateIsSet: {
			triggerOn: 'vat_rate',
			triggerWhen: rate => !!rate,
			dataMutations: bf => {
				bf.patchValues({
					query: null,
					new_state: 50
				});
			}
		},

		invalidatePaymentDataIfQueryIsSet: {
			triggerOn: 'query',
			triggerWhen: qr => !!qr,
			dataMutations: bf => {
				bf.patchValues({
					claim_value: null,
					update_excess: null,
					invoice_number: null,
					vat_rate: null,
					nextApprovalStaffName: null,
					new_state: 47
				});
			}
		}
	},
	actionPanel: instance => setActionPanelItems(instance, ['job-card', 'notes', 'documents', 'sp-details']),
	fetchLevel1And2: true,
	serverCalls: {
		invoice: {
			serviceVariable: 'betService',
			functionName: 'getJobInvoice',
			errorMessage: 'Could not get files from server!'
		},
		files: {
			serviceVariable: 'betService',
			functionName: 'getAllJobFiles',
			responseSlice: 'payload',
			errorMessage: 'Could not get files from server!'
		}
	},

	startNode: 'MiscellaneousClass',

	nodes: {
		...MISCELLANEOUS_CLAIMS_PAYMENT_CHECKS?.nodes,
		...PAYMENT_CHECKS?.nodes,
		...BET_27.nodes
	},

	bigFormToStoreMapper: {
		...BET_27.bigFormToStoreMapper
	}
};
